var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hnylf16e2a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.52.2H13v12.48H.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.761 4.36v2.08m0 2.08h.005m-.894-6.833L1.467 9.04a1.04 1.04 0 0 0 .89 1.56h8.808a1.041 1.041 0 0 0 .89-1.56L7.65 1.687a1.04 1.04 0 0 0-1.778 0z",
    stroke: "#A12512",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hnylf16e2a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.52 .2)",
    d: "M0 0h12.48v12.48H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIcon);
export default __webpack_public_path__ + "static/media/exclamationIcon.2c65664defac3bd1b19407f52584cf78.svg";
export { ForwardRef as ReactComponent };